export class Delimiter {
    id: string;

    displayText: string;

    constructor(id: string, displayText?: string | null) {
        this.id = id;
        this.displayText = displayText || "";
    }
}
